import { ErrorWithViolations as e } from "./error-with-violations.mjs";
//#region src/errors/unprocessable-content-error.ts
var t = class extends e {};
//#endregion
export { t as UnprocessableContentError };
